import React from 'react'
import {QuoteDetailListTable} from "../Component/QuoteDetailListTable";

const PendingTabList = (props) => {
    return (
        <div>
            <QuoteDetailListTable {...props}/>
        </div>
    )
};

export default PendingTabList